<div class="dialog">
  <div class="dialog-header">
    <div class="dialog-heading">
      <span class="dialog-title">
        Assigned status — Room {{ data.roomNumber }}
      </span>

      @if(utsavName) {
      <span class="dialog-subtitle">
        {{ utsavName }} · Capacity {{ capacity }}
        @if(accommodationStartDate) {
        · {{ accommodationStartDate }} to {{ accommodationEndDate }}
        }
      </span>
      }
    </div>

    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">
      ×
    </button>
  </div>

  @if(!hasLoaded) {
  <div class="muted">Loading occupancy…</div>
  } @else if(hasError) {
  <div class="muted">
    Could not load the occupancy for this room.
  </div>
  } @else {

  @if(hasNoBlockedDates) {
  <div class="muted">
    No blocked dates for this utsav — the room has no bed assignments here.
  </div>
  }

  <div class="calendar-header">
    <button type="button" class="ac-icon-btn" (click)="previousMonth()" title="Previous month">
      <span class="material-icons">chevron_left</span>
    </button>

    <span class="month-label">
      {{ monthLabel }}
    </span>

    <button type="button" class="ac-icon-btn" (click)="nextMonth()" title="Next month">
      <span class="material-icons">chevron_right</span>
    </button>
  </div>

  <div class="calendar-grid">
    @for(weekDay of weekDays; track weekDay) {
    <span class="weekday">{{ weekDay }}</span>
    }

    @for(cell of monthCells; track $index) {
    @if(cell === null) {
    <span class="day-cell blank"></span>
    } @else {
    <span class="day-cell" [class.outside]="!cell.inWindow" [class.blocked]="cell.occupied > 0">
      <span class="day-number">
        {{ cell.day }}
      </span>

      @if(cell.occupied > 0) {
      <span class="bed-count">
        {{ cell.occupied }}/{{ capacity }}
      </span>
      }
    </span>
    }
    }
  </div>

  <span class="muted legend">
    Days marked show occupied beds / capacity for this utsav.
  </span>
  }

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" [disabled]="isLoading" (click)="close()">
      Close
    </button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>